<div class="game-media">
  <div class="header">
    <div class="date">{{ game.datetime | date: 'dd MMMM' }}</div>
    <div class="score">
      <div class="team">
        {{ game.team.name }}
        <span class="value">{{ game.teamScore }}</span>
      </div>
      <div class="vs"><mtg-svg-icon icon="icons-vs"></mtg-svg-icon></div>
      <div class="team">
        <span class="value">{{ game.competitorTeamScore }}</span>
        {{ game.competitorTeam.name }}
      </div>
    </div>
    <div class="count">
      <mtg-svg-icon icon="icons-media"></mtg-svg-icon>
      {{ game.media.length }}
    </div>
  </div>
  <ng-container *ngIf="video.length > 0">
    <div class="title" *ngIf="photos.length > 0">Видео</div>
    <mtg-game-media-video [game]="game" [video]="video" [mediaRoute]="mediaRoute"></mtg-game-media-video>
  </ng-container>
  <ng-container *ngIf="photos.length > 0">
    <div class="title" *ngIf="video.length > 0">Фото</div>
    <mtg-game-media-images [game]="game" [images]="photos" [mediaRoute]="mediaRoute"></mtg-game-media-images>
  </ng-container>
</div>
